var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondaryPhonenumberPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.469,
    height: 17.502,
    viewBox: "0 0 17.469 17.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161410",
    "data-name": "Group 161410",
    transform: "translate(-26.249 -95.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161285",
    "data-name": "Group 161285",
    transform: "translate(-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hover-Change_Phonenumber",
    "data-name": "Hover-Change Phonenumber",
    transform: "translate(40 96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M18.08,13.979v2.409a1.606,1.606,0,0,1-1.75,1.606A15.889,15.889,0,0,1,9.4,15.529a15.656,15.656,0,0,1-4.817-4.817A15.889,15.889,0,0,1,2.118,3.75,1.606,1.606,0,0,1,3.716,2H6.125A1.606,1.606,0,0,1,7.731,3.381a10.309,10.309,0,0,0,.562,2.256,1.606,1.606,0,0,1-.361,1.694l-1.02,1.02a12.846,12.846,0,0,0,4.817,4.817l1.02-1.02a1.606,1.606,0,0,1,1.694-.361,10.309,10.309,0,0,0,2.256.562,1.606,1.606,0,0,1,1.381,1.63Z",
    transform: "translate(-2.112 -2)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "corner-up-right",
    transform: "translate(49.156 96.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M15,7.756l1.878-1.878L15,4",
    transform: "translate(-10.869 -4)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M4,13.131V10.5A1.5,1.5,0,0,1,5.5,9h4.507",
    transform: "translate(-4 -7.122)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryPhonenumberPrimaryIcon);
export default __webpack_public_path__ + "static/media/secondary-phonenumber-primary-icon.e78a824917a29b50327feb1648072429.svg";
export { ForwardRef as ReactComponent };